/* Staggers the hero heading and statement in when the section reaches the
   viewport. The stagger index is set here rather than in Liquid because the
   pieces that animate differ between phone and desktop. */
(() => {
  const init = (root) => {
    if (root.dataset.phReady) return;
    root.dataset.phReady = 'true';

    if (root.hasAttribute('data-ph-static')) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const parts = root.querySelectorAll(
      '.ph__title-mobile, .ph__seg, .ph__title-img, .ph__body-text'
    );
    if (!parts.length) return;

    parts.forEach((el, i) => el.style.setProperty('--ph-i', i));
    root.setAttribute('data-ph-split', '');

    const reveal = () => root.setAttribute('data-ph-in', '');

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          reveal();
          observer.disconnect();
        });
      },
      { threshold: 0.15 }
    );
    observer.observe(root);

    // Never leave the heading invisible if the observer somehow does not fire.
    setTimeout(reveal, 3000);
  };

  const scan = (scope) => scope.querySelectorAll('[data-ph]').forEach(init);

  scan(document);
  document.addEventListener('shopify:section:load', (event) => scan(event.target));
})();
